import { useState, useEffect } from 'preact/hooks'

// Custom hook to track URL changes
function useURL() {
  const [url, setURL] = useState(window.location.href)

  const handleURLChange = () => {
    setURL(() => `${window.location.href}&timestamp=${new Date().getTime()}`)
  }

  useEffect(() => {
    // Add event listener for popstate to handle browser navigation
    window.addEventListener('popstate', handleURLChange)

    // Clean up event listeners on component unmount
    return () => {
      window.removeEventListener('popstate', handleURLChange)
    }
  }, [])

  return url
}

export default useURL
